<template>
  <div class="wangwang-container">
    <!-- 背景图片 -->
    <div class="background-image"></div>
    
    <!-- 主内容区域 -->
    <div class="content-wrapper">
      <!-- 标题区域 -->
      <div class="title-section">
        <h1>雪碧旅行日记</h1>
        <p>再见了妈妈今晚我就要远航～</p>
      </div>
      
      <!-- 日记列表区域 -->
      <div class="diary-list-section">
        <el-table
          :data="currentPageData"
          style="width: 100%"
          :header-cell-style="{background:'#f5f7fa',color:'#606266'}"
          @row-click="handleRowClick"
        >
          <el-table-column
            prop="date"
            label="日期"
            width="130"
            align="center"
          >
            <template #default="{row}">
              <div class="date-cell">{{ row.date }}</div>
            </template>
          </el-table-column>
          
          <el-table-column
            prop="location"
            label="地点"
            width="150"
            align="center"
          >
            <template #default="{row}">
              <el-tag :type="getLocationTagType(row.location)">{{ row.location }}</el-tag>
            </template>
          </el-table-column>
          
          <el-table-column
            label="照片"
            width="120"
            align="center"
          >
            <template #default="{row}">
              <img :src="row.thumbnail" class="thumbnail-image" alt="旅行照片">
            </template>
          </el-table-column>
          
          <el-table-column
            prop="content"
            label="日记内容"
          >
            <template #default="{row}">
              <div class="content-cell">{{ truncateContent(row.content) }}</div>
            </template>
          </el-table-column>
          
          <el-table-column
            label="操作"
            width="100"
            align="center"
          >
            <template #default="{row}">
              <el-button type="text" @click.stop="showDiaryDetail(row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        
        <!-- 分页控件 -->
        <div class="pagination-section">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="diaryData.length"
            background
          >
          </el-pagination>
        </div>
      </div>
    </div>
    
    <!-- 日记详情弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      custom-class="diary-dialog"
      width="90%"
      :before-close="handleClose"
    >
      <div class="dialog-content">
        <div class="diary-image">
          <img :src="currentDiary.image" alt="旅行照片">
        </div>
        <div class="diary-info">
          <div class="info-row">
            <span class="info-label">日期：</span>
            <span class="info-value">{{ currentDiary.date }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">地点：</span>
            <span class="info-value">{{ currentDiary.location }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">天气：</span>
            <span class="info-value">{{ currentDiary.weather }}</span>
          </div>
        </div>
        <div class="diary-content">
          {{ currentDiary.content }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/services/api";

export default {
  name: 'WangWangTravelDiary',
  data() {
    return {
      diaryData: [],
      currentPage: 1,
      pageSize: 5,
      dialogVisible: false,
      currentDiary: {},
      location: "",
      startDate: "",
      endDate: "",
    }
  },
  computed: {
    currentPageData() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.diaryData.slice(start, end)
    }
  },
  mounted() {
    this.xuebiTravelDiary(); 
  },
  methods: {
    xuebiTravelDiary() {
      const params = {
        page: this.currentPage,      // 当前页码
        page_size: this.pageSize,    // 每页条数
        location: this.location,     // 地点筛选
        start_date: this.startDate,  // 开始日期
        end_date: this.endDate       // 结束日期
       };

      api.xuebiTravelDiary(params).then((res) => {
        if (res.code === 200) {
            this.diaryData = res.data.data.map(item => ({
            id: item.id,
            date: item.travel_date,
            location: item.location,
            thumbnail: item.photos , // 默认缩略图
            image: item.photos, // 默认大图
            content: item.content
            }));
            this.total = res.data.total;
        }
        });
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    truncateContent(content) {
      return content.length > 50 ? content.substring(0, 50) + '...' : content
    },
    showDiaryDetail(row) {
      this.currentDiary = row
      this.dialogVisible = true
    },
    handleRowClick(row) {
      this.showDiaryDetail(row)
    },
    handleClose(done) {
      done()
    },
    getLocationTagType(location) {
      const types = ['', 'success', 'success', 'warning', 'danger']
      const index = location.length % types.length
      return types[index]
    }
  }
}
</script>

<style scoped>
.wangwang-container {
  width: 100%;
  min-height: 100vh;
  position: relative;
  background-color: #f0f8ff;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  overflow-x: hidden;
}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('https://images.unsplash.com/photo-1586671267731-da2cf3ceeb80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80');
  background-size: cover;
  background-position: center;
  opacity: 0.1;
  z-index: 0;
}

.content-wrapper {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.title-section {
  text-align: center;
  margin-bottom: 30px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.title-section h1 {
  color: #409EFF;
  font-size: 36px;
  margin-bottom: 10px;
  font-weight: bold;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.title-section p {
  color: #57606f;
  font-size: 18px;
}

.diary-list-section {
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 15px;
  padding: 20px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.date-cell {
  font-weight: bold;
  color: #2f3542;
}

.thumbnail-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 8px;
  border: 2px solid orange;
}

.content-cell {
  color: #57606f;
  cursor: pointer;
}

.content-cell:hover {
  color: #409EFF;
}

.pagination-section {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

/* 弹窗样式 */
::v-deep .diary-dialog {
  border-radius: 15px;
  max-width: 400px; /* 9:16比例 */
  height: 711px; /* 400 * 16/9 ≈ 711 */
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.dialog-content {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.diary-image {
  flex: 1;
  overflow: hidden;
  border-radius: 10px;
  margin-bottom: 15px;
}

.diary-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.diary-info {
  background-color: rgba(255, 255, 255, 0.8);
  padding: 15px;
  border-radius: 10px;
  margin-bottom: 15px;
}

.info-row {
  display: flex;
  margin-bottom: 8px;
}

.info-label {
  font-weight: bold;
  color: #2f3542;
  width: 60px;
}

.info-value {
  color: #57606f;
  flex: 1;
}

.diary-content {
  flex: 1;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 15px;
  border-radius: 10px;
  overflow-y: auto;
  color: #57606f;
  line-height: 1.6;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .content-wrapper {
    padding: 10px;
  }
  
  .title-section h1 {
    font-size: 28px;
  }
  
  .title-section p {
    font-size: 16px;
  }
  
  ::v-deep .diary-dialog {
    width: 95%;
    height: auto;
    max-height: 90vh;
  }
  
  .thumbnail-image {
    width: 60px;
    height: 60px;
  }
}

/* 动画效果 */
.el-table__row {
  transition: all 0.3s ease;
}

.el-table__row:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.el-button--text {
  color: orange;
  transition: all 0.3s ease;
}

.el-button--text:hover {
  color: #409EFF;
  transform: scale(1.05);
}
</style>


// WEBPACK FOOTER //
// src/components/TravelXuebi.vue